/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { a as isFunction_1 } from '../_chunks/dep-95834911.js';
import { i as isString_1 } from '../_chunks/dep-3fecfff7.js';
import '../_chunks/dep-9fe8d051.js';
import '../_chunks/dep-0e9724f2.js';
import '../_chunks/dep-f771ed13.js';
import '../_chunks/dep-a4df350d.js';
import '../_chunks/dep-00b2fb56.js';
import '../_chunks/dep-818f0859.js';

function resolveContainer(getContainer) {
  if (isString_1(getContainer)) {
    return getContainer ? document.querySelector(getContainer) : window;
  }
  if (isFunction_1(getContainer)) {
    return getContainer();
  }
  return getContainer;
}

export { resolveContainer };
//# sourceMappingURL=getContainer.js.map
